// bank_promptpay_v1: จัดการบัญชีธนาคาร + พร้อมเพย์ สำหรับรับชำระบิล
import React, { useState, useEffect } from 'react';
import API from '../api';

var THAI_BANKS = ['กสิกรไทย (KBANK)', 'ไทยพาณิชย์ (SCB)', 'กรุงเทพ (BBL)', 'กรุงไทย (KTB)', 'กรุงศรีอยุธยา (BAY)', 'ทหารไทยธนชาต (ttb)', 'ออมสิน (GSB)', 'ธ.ก.ส. (BAAC)', 'เกียรตินาคินภัทร (KKP)', 'ซีไอเอ็มบี (CIMB)', 'ยูโอบี (UOB)', 'แลนด์ แอนด์ เฮ้าส์ (LH Bank)', 'ไทยเครดิต (TCD)'];

function emptyForm() {
  return { id: null, bank_code: '', account_number: '', account_name: '', branch: '', promptpay_id: '', promptpay_type: 'mobile', is_primary: false, note: '', qr_image_url: '', qr_payload: '' };
}

export default function BillBankAccounts() {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyForm());
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [uploadingQr, setUploadingQr] = useState(false); /* qr_image_v1 */
  const [slipAuto, setSlipAuto] = useState(false); /* bill_slip_autoverify_v1 */
  const [slipAutoHasToken, setSlipAutoHasToken] = useState(true);
  const [slipAutoSaving, setSlipAutoSaving] = useState(false);
  const overlayMouseDown = React.useRef(false);

  useEffect(function () {
    API.get('/api/bill/settings/slip-auto')
      .then(function (r) { setSlipAuto(!!(r.data && r.data.enabled)); setSlipAutoHasToken(r.data ? r.data.has_token !== false : true); })
      .catch(function () {});
  }, []);
  function toggleSlipAuto() {
    var next = !slipAuto;
    setSlipAutoSaving(true);
    API.patch('/api/bill/settings/slip-auto', { enabled: next })
      .then(function () { setSlipAuto(next); })
      .catch(function () {})
      .finally(function () { setSlipAutoSaving(false); });
  }

  /* qr_image_v1: เลือกรูป → base64 → อัปโหลด → เก็บ url */
  function onPickQr(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { setError('รูปใหญ่เกิน 5MB'); return; }
    var reader = new FileReader();
    reader.onload = function () {
      setUploadingQr(true); setError('');
      API.post('/api/bank-accounts/upload-qr', { image_base64: reader.result })
        .then(function (r) { upd('qr_image_url', r.data.url); })
        .catch(function (er) { setError((er.response && er.response.data && er.response.data.error) || 'อัปโหลดรูปไม่สำเร็จ'); })
        .finally(function () { setUploadingQr(false); });
    };
    reader.readAsDataURL(file);
  }

  function load() {
    setLoading(true);
    API.get('/api/bank-accounts')
      .then(function (r) { setAccounts(Array.isArray(r.data) ? r.data : []); })
      .catch(function () { setAccounts([]); })
      .finally(function () { setLoading(false); });
  }
  useEffect(function () { load(); }, []);

  function openAdd() { setForm(emptyForm()); setError(''); setShowForm(true); }
  function openEdit(a) {
    setForm({
      id: a.id, bank_code: a.bank_code || '', account_number: a.account_number || '',
      account_name: a.account_name || '', branch: a.branch || '',
      promptpay_id: a.promptpay_id || '', promptpay_type: a.promptpay_type || 'mobile',
      is_primary: !!a.is_primary, note: a.note || '', qr_image_url: a.qr_image_url || '', qr_payload: a.qr_payload || ''
    });
    setError(''); setShowForm(true);
  }
  function upd(k, v) { setForm(Object.assign({}, form, (function () { var o = {}; o[k] = v; return o; })())); }

  async function save() {
    /* bank_optional_v1 + qr_payload_v1: ต้องมีอย่างน้อย 1 ช่องทาง */
    if (!form.account_number.trim() && !form.promptpay_id.trim() && !form.qr_image_url && !form.qr_payload.trim()) {
      setError('ต้องมีอย่างน้อย 1 ช่องทาง: เลขบัญชี / พร้อมเพย์-Biller / รูป QR / โค้ด QR'); return;
    }
    if (form.qr_payload.trim() && !/^000201/.test(form.qr_payload.trim())) {
      setError('โค้ด QR ไม่ถูกต้อง (ต้องขึ้นต้นด้วย 000201)'); return;
    }
    if (form.account_number.trim() && !form.account_name.trim()) {
      setError('ใส่เลขบัญชีแล้ว กรุณาใส่ชื่อบัญชีด้วย'); return;
    }
    setSaving(true); setError('');
    var payload = {
      bank_code: form.bank_code.trim(),
      account_number: form.account_number.trim(),
      account_name: form.account_name.trim(),
      branch: form.branch.trim() || null,
      is_primary: form.is_primary,
      note: form.note.trim() || null,
      promptpay_id: form.promptpay_id.trim() || null,
      promptpay_type: form.promptpay_id.trim() ? form.promptpay_type : null,
      qr_image_url: form.qr_image_url || null,
      qr_payload: form.qr_payload.trim() || null
    };
    try {
      if (form.id) { await API.put('/api/bank-accounts/' + form.id, payload); }
      else { await API.post('/api/bank-accounts', payload); }
      setShowForm(false); load();
    } catch (e) {
      setError((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ');
    } finally { setSaving(false); }
  }

  async function remove(a) {
    if (!window.confirm('ลบบัญชี ' + (a.bank_code || '') + ' ' + (a.account_number || '') + ' ?')) return;
    try { await API.delete('/api/bank-accounts/' + a.id); load(); }
    catch (e) { alert((e.response && e.response.data && e.response.data.error) || 'ลบไม่สำเร็จ'); }
  }

  var inputStyle = { width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box', fontFamily: 'inherit' };
  var labelStyle = { fontSize: 13, color: '#64748b', fontWeight: 600 };

  return (
    <div style={{ padding: 20, maxWidth: 900, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' }}>🏦 บัญชี / พร้อมเพย์</h2>
        <button onClick={openAdd} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#10b981', color: 'white', fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>+ เพิ่มบัญชี</button>
      </div>
      <p style={{ color: '#64748b', fontSize: 13, marginTop: 0, marginBottom: 16 }}>บัญชีที่เพิ่มไว้จะเลือกใช้ตอนสร้างบิลได้ และลูกค้าจะเห็นในหน้าชำระเงิน (พร้อมเพย์จะสร้าง QR ให้อัตโนมัติ)</p>

      {/* bill_slip_autoverify_v1: ปุ่มเปิด-ปิดตรวจสลิปอัตโนมัติ (แยกจากระบบแชท) */}
      <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, color: '#0f172a' }}>🤖 ตรวจสลิปอัตโนมัติ (slip2go)</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>เมื่อลูกค้าอัปสลิป ระบบตรวจให้อัตโนมัติ — ถ้ายอด + บัญชีผู้รับตรง จะมาร์คบิลเป็น "จ่ายแล้ว" ทันที (แยกจากระบบแชท)</div>
          {!slipAutoHasToken ? <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4 }}>⚠️ ยังไม่ได้ตั้งค่า Slip2Go token — ติดต่อแอดมิน</div> : null}
        </div>
        <button onClick={toggleSlipAuto} disabled={slipAutoSaving}
          title={slipAuto ? 'เปิดอยู่' : 'ปิดอยู่'}
          style={{ width: 52, height: 30, borderRadius: 999, border: 'none', cursor: slipAutoSaving ? 'wait' : 'pointer', background: slipAuto ? '#10b981' : '#cbd5e1', position: 'relative', transition: 'background .2s', flexShrink: 0 }}>
          <span style={{ position: 'absolute', top: 3, left: slipAuto ? 25 : 3, width: 24, height: 24, borderRadius: '50%', background: 'white', transition: 'left .2s' }} />
        </button>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>กำลังโหลด...</div>
      ) : accounts.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8', background: 'white', borderRadius: 12, border: '1px dashed #cbd5e1' }}>ยังไม่มีบัญชี — กด "+ เพิ่มบัญชี"</div>
      ) : (
        <div style={{ display: 'grid', gap: 10 }}>
          {accounts.map(function (a) {
            return (
              <div key={a.id} style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16, display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontWeight: 700, color: '#0f172a' }}>{a.bank_code}</span>
                    {a.is_primary ? <span style={{ fontSize: 11, background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: 999 }}>หลัก</span> : null}
                    {!a.is_active ? <span style={{ fontSize: 11, background: '#f1f5f9', color: '#94a3b8', padding: '2px 8px', borderRadius: 999 }}>ปิด</span> : null}
                  </div>
                  <div style={{ fontFamily: 'monospace', fontSize: 15, marginTop: 2 }}>{a.account_number}</div>
                  <div style={{ fontSize: 13, color: '#64748b' }}>{a.account_name}{a.branch ? ' · ' + a.branch : ''}</div>
                  {a.promptpay_id ? <div style={{ fontSize: 13, color: '#0ea5e9', marginTop: 2 }}>📱 พร้อมเพย์: {a.promptpay_id}</div> : null}
                  {a.qr_image_url ? <div style={{ fontSize: 13, color: '#a16207', marginTop: 2 }}>🖼️ มี QR ร้านค้า</div> : null}
                  {a.qr_payload ? <div style={{ fontSize: 13, color: '#16a34a', marginTop: 2 }}>🏪 มีโค้ด QR (Thai QR/แม่มณี)</div> : null}
                </div>
                {a.qr_image_url ? <img src={a.qr_image_url} alt="QR" style={{ width: 44, height: 44, objectFit: 'contain', border: '1px solid #e2e8f0', borderRadius: 6, background: 'white' }} /> : null}
                <button onClick={function () { openEdit(a); }} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: 13 }}>แก้ไข</button>
                <button onClick={function () { remove(a); }} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #fecaca', background: '#fef2f2', color: '#b91c1c', cursor: 'pointer', fontSize: 13 }}>ลบ</button>
              </div>
            );
          })}
        </div>
      )}

      {showForm && (
        <div
          onMouseDown={function (e) { overlayMouseDown.current = (e.target === e.currentTarget); }}
          onClick={function (e) { if (!saving && e.target === e.currentTarget && overlayMouseDown.current) setShowForm(false); }}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 100 }}>
          <div onClick={function (e) { e.stopPropagation(); }} style={{ background: 'white', borderRadius: 14, padding: 24, maxWidth: 460, width: '100%', maxHeight: '92vh', overflowY: 'auto' }}>
            <h3 style={{ margin: '0 0 6px' }}>{form.id ? 'แก้ไขบัญชี' : 'เพิ่มบัญชี'}</h3>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 14 }}>💡 ใส่อย่างน้อย 1 ช่องทาง — ถ้าใช้พร้อมเพย์/Biller อย่างเดียว เว้นช่องธนาคารได้</div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>ธนาคาร</label>
              <input list="thaibanks" value={form.bank_code} onChange={function (e) { upd('bank_code', e.target.value); }} placeholder="เลือกหรือพิมพ์ชื่อธนาคาร" style={inputStyle} />
              <datalist id="thaibanks">{THAI_BANKS.map(function (b) { return <option key={b} value={b} />; })}</datalist>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>เลขที่บัญชี</label>
              <input value={form.account_number} onChange={function (e) { upd('account_number', e.target.value); }} placeholder="xxx-x-xxxxx-x" style={inputStyle} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>ชื่อบัญชี / ชื่อร้าน</label>
              <input value={form.account_name} onChange={function (e) { upd('account_name', e.target.value); }} placeholder="ชื่อเจ้าของบัญชี" style={inputStyle} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>สาขา</label>
              <input value={form.branch} onChange={function (e) { upd('branch', e.target.value); }} style={inputStyle} />
            </div>
            <div style={{ marginBottom: 12, padding: 12, background: '#f0f9ff', borderRadius: 8, border: '1px solid #e0f2fe' }}>
              <label style={labelStyle}>📱 พร้อมเพย์ / Biller ID (ไม่บังคับ — ใส่เพื่อสร้าง QR อัตโนมัติ)</label>
              <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                <select value={form.promptpay_type} onChange={function (e) { upd('promptpay_type', e.target.value); }} style={{ ...inputStyle, maxWidth: 170, marginTop: 0 }}>
                  <option value="mobile">เบอร์มือถือ</option>
                  <option value="nid">เลขบัตร ปชช.</option>
                  <option value="biller">Biller ID (แม่มณี)</option>
                </select>
                <input value={form.promptpay_id} onChange={function (e) { upd('promptpay_id', e.target.value); }} placeholder={form.promptpay_type === 'nid' ? '13 หลัก' : (form.promptpay_type === 'biller' ? '15 หลัก' : '08x-xxx-xxxx')} style={{ ...inputStyle, marginTop: 0 }} />
              </div>
            </div>
            {/* qr_image_v1: อัปโหลดรูป QR ร้านค้า (แม่มณี / K SHOP ฯลฯ) */}
            <div style={{ marginBottom: 12, padding: 12, background: '#fefce8', borderRadius: 8, border: '1px solid #fef08a' }}>
              <label style={labelStyle}>🖼️ รูป QR ร้านค้า (ไม่บังคับ — เช่น แม่มณี, K SHOP)</label>
              <div style={{ fontSize: 11, color: '#94a3b8', margin: '2px 0 8px' }}>QR ที่สร้างเองไม่ได้ (มี ID ร้านค้าเฉพาะ) ให้อัปโหลดรูปจากแอปธนาคาร — ลูกค้าพิมพ์ยอดเอง</div>
              {form.qr_image_url ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <img src={form.qr_image_url} alt="QR" style={{ width: 90, height: 90, objectFit: 'contain', border: '1px solid #e2e8f0', borderRadius: 8, background: 'white' }} />
                  <button type="button" onClick={function () { upd('qr_image_url', ''); }} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #fecaca', background: '#fef2f2', color: '#b91c1c', cursor: 'pointer', fontSize: 13 }}>ลบรูป</button>
                </div>
              ) : (
                <label style={{ display: 'inline-block', padding: '8px 14px', borderRadius: 8, border: '1px dashed #ca8a04', background: 'white', color: '#a16207', cursor: uploadingQr ? 'wait' : 'pointer', fontSize: 13, fontWeight: 600 }}>
                  {uploadingQr ? 'กำลังอัปโหลด...' : '+ เลือกรูป QR'}
                  <input type="file" accept="image/*" onChange={onPickQr} disabled={uploadingQr} style={{ display: 'none' }} />
                </label>
              )}
            </div>
            {/* qr_payload_v1: วางโค้ด QR (Thai QR/แม่มณี) — สร้าง QR จากโค้ดจริง สแกนได้ 100% */}
            <div style={{ marginBottom: 12, padding: 12, background: '#f0fdf4', borderRadius: 8, border: '1px solid #bbf7d0' }}>
              <label style={labelStyle}>🏪 โค้ด QR ร้านค้า (Thai QR / แม่มณี) — แนะนำ</label>
              <div style={{ fontSize: 11, color: '#94a3b8', margin: '2px 0 8px' }}>ใช้แอปสแกน QR ธรรมดา (เช่น Google Lens) สแกน QR แม่มณี → ก๊อปข้อความ (ขึ้นต้น 000201...) มาวางที่นี่ → ระบบสร้าง QR ตรงตามตัวจริง</div>
              <textarea value={form.qr_payload} onChange={function (e) { upd('qr_payload', e.target.value); }} rows={3} placeholder="000201010211..." style={{ ...inputStyle, fontFamily: 'monospace', fontSize: 12, resize: 'vertical' }} />
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, color: '#334155', cursor: 'pointer', marginBottom: 12 }}>
              <input type="checkbox" checked={form.is_primary} onChange={function (e) { upd('is_primary', e.target.checked); }} /> ตั้งเป็นบัญชีหลัก
            </label>
            {error ? <div style={{ color: '#dc2626', fontSize: 13, marginBottom: 10 }}>{error}</div> : null}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button onClick={function () { setShowForm(false); }} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: 14 }}>ยกเลิก</button>
              <button onClick={save} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: saving ? '#94a3b8' : '#10b981', color: 'white', cursor: saving ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 600 }}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
